export const Group = ({ title, children }) => (
  <div className="space-y-3 pb-5 border-b border-slate-800 last:border-0">
    {title && <p className="text-[10px] font-mono uppercase tracking-[0.18em] text-slate-500">{title}</p>}
    {children}
  </div>
);

export const Row = ({ label, children }) => (
  <label className="flex items-center gap-3">
    <span className="shrink-0 min-w-[2.5rem] max-w-[5rem] text-[11px] text-slate-400">{label}</span>
    <div className="flex-1 min-w-0">{children}</div>
  </label>
);

export const Num = ({ value, onChange, step = 0.1, min, max, testId, suffix }) => (
  <div className="relative">
    <input type="number" step={step} min={min} max={max} value={Number.isFinite(value) ? value : 0}
      onChange={(e) => onChange(e.target.value === "" ? 0 : parseFloat(e.target.value))}
      className="cf-input h-8 text-xs font-mono pr-8" data-testid={testId} />
    {suffix && <span className="absolute right-2 top-1/2 -translate-y-1/2 text-[10px] text-slate-500 font-mono pointer-events-none">{suffix}</span>}
  </div>
);

const isHex = (v) => /^#[0-9a-f]{6}$/i.test(v || "");

export const Color = ({ value, onChange, testId, allowNone }) => (
  <div className="flex items-center gap-2">
    <input type="color" value={isHex(value) ? value : "#000000"} onChange={(e) => onChange(e.target.value)}
      className="h-8 w-9 shrink-0 rounded-md bg-transparent border border-slate-700 cursor-pointer p-0.5" data-testid={testId} />
    <input value={value || ""} onChange={(e) => onChange(e.target.value)} className="cf-input h-8 text-[11px] font-mono" data-testid={testId ? `${testId}-text` : undefined} />
    {allowNone && (
      <button onClick={() => onChange("transparent")} className="text-[10px] text-slate-400 hover:text-white px-1" data-testid={testId ? `${testId}-none` : undefined}>none</button>
    )}
  </div>
);

export const Select = ({ value, onChange, options, testId }) => (
  <select value={value} onChange={(e) => onChange(e.target.value)} className="cf-input h-8 text-xs" data-testid={testId}>
    {options.map((o) => (typeof o === "string" ? <option key={o} value={o}>{o}</option> : <option key={o.value} value={o.value}>{o.label}</option>))}
  </select>
);

export const Seg = ({ value, onChange, options, testId }) => (
  <div className="flex bg-slate-950 border border-slate-800 rounded-md p-0.5" data-testid={testId}>
    {options.map((o) => (
      <button key={o.value} onClick={() => onChange(o.value)} title={o.title || o.value} data-testid={`${testId}-${o.value}`}
        className={`flex-1 h-7 grid place-items-center rounded text-xs transition-colors ${value === o.value ? "bg-slate-700 text-white" : "text-slate-400 hover:text-white"}`}>
        {o.label}
      </button>
    ))}
  </div>
);
